import React from 'react';
import { Alert, Form } from 'antd';
import { isTutorialUiSuppressionRequested } from '../utils/tutorialMode';

interface OriginalMetadataEditorProps {
  hasUnsavedChanges: boolean;
  isTitleValid: boolean;
  children: React.ReactNode;
}

const OriginalMetadataEditor: React.FC<OriginalMetadataEditorProps> = ({
  hasUnsavedChanges,
  isTitleValid,
  children,
}) => (
  <div className="metadata-content-shell metadata-original-editor">
    <div className="metadata-content-scroll">
      {hasUnsavedChanges && !isTutorialUiSuppressionRequested() && (
        <Alert
          message="You have unsaved changes in your metadata."
          type="warning"
          showIcon
          className="metadata-dirty-alert"
        />
      )}
      <Form layout="vertical" className="metadata-editor-form">
        {children}
      </Form>
      {!isTitleValid && <Alert message="Title is required." type="error" showIcon className="metadata-title-alert" />}
    </div>
  </div>
);

export default OriginalMetadataEditor;
